import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EventType } from '@azure/msal-browser';
import AuthContext from './AuthContext';
import StaticLoader from '../components/mui/MuiLoader/StaticLoader/StaticLoader';
import {
  getUserAccount,
  getUXSettings,
  getUserToken,
  getUserError,
} from '../features/UserSelectors';
import { userLoginSuccess, getUserUXSettings } from '../features/UserSlice';
import { getLoginRequest } from './config';
import AutoLogout from './AutoLogout';
import Error from '../containers/Error';

const Auth = ({ children }) => {
  const msalInstance = useContext(AuthContext);
  const dispatch = useDispatch();
  const user = useSelector(getUserAccount);
  const uxSettings = useSelector(getUXSettings);
  const userToken = useSelector(getUserToken);
  const userError = useSelector(getUserError);

  useEffect(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback(
      async (event) => {
        if (
          event.eventType === EventType.LOGIN_SUCCESS &&
          event.payload.account
        ) {
          const account = event.payload.account;
          dispatch(userLoginSuccess({ account, token: event.payload.idToken }));
          msalInstance.setActiveAccount(account);
        }
      },
      (error) => {
        console.log('Auth login error', error);
      }
    );

    // handle auth redirect/do all initial setup for msal
    msalInstance
      .handleRedirectPromise()
      .then(async () => {
        try {
          // Check if user signed in
          const activeAccount = msalInstance.getActiveAccount();
          if (!activeAccount) {
            // redirect anonymous user to login page
            throw new Error('No active acccount');
          }
          const response = await msalInstance.acquireTokenSilent(
            getLoginRequest()
          );
          const { account, idToken: token } = response;
          dispatch(userLoginSuccess({ account, token }));
        } catch (error) {
          msalInstance.loginRedirect({
            postLogoutRedirectUri: window.location.href,
          });
        }
      })
      .catch((error) => {
        console.log('Auth handleRedirectPromise error', error);
        msalInstance.loginRedirect({
          postLogoutRedirectUri: window.location.href,
        });
      });
  }, []);

  useEffect(() => {
    if (userToken) {
      dispatch(getUserUXSettings());
    }
  }, [userToken]);

  if (userError) return <Error />;

  if (!user || !uxSettings) return <StaticLoader />;

  return (
    <>
      <AutoLogout />
      {children}
    </>
  );
};

export default Auth;
